import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check, Users } from 'lucide-react';
import { GroupId, GROUPS } from '../../config/systemConfig';
interface GroupSelectorProps {
  selectedGroup: GroupId;
  onSelect: (group: GroupId) => void;
  isCollapsed?: boolean;
}
export function GroupSelector({
  selectedGroup,
  onSelect,
  isCollapsed = false
}: GroupSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  if (isCollapsed) {
    return <div className="flex justify-center mb-6" data-id="element-3656">
        <button onClick={() => setIsOpen(!isOpen)} className="w-12 h-12 rounded-2xl bg-indigo-600 text-white flex items-center justify-center font-bold shadow-lg shadow-indigo-200 hover:bg-indigo-700 hover:scale-105 transition-all" title={`Huidige groep: ${selectedGroup}`} data-id="element-3657">

          {selectedGroup}
        </button>
      </div>;
  }
  return <div className="relative" ref={containerRef} data-id="element-3658">
      <button onClick={() => setIsOpen(!isOpen)} className={`
          w-full flex items-center justify-between p-2.5 rounded-2xl border-2 transition-all duration-200 group
          ${isOpen ? 'bg-indigo-50 border-indigo-200' : 'bg-white border-slate-100 hover:border-indigo-200 hover:bg-slate-50 shadow-sm'}
        `} data-id="element-3659">

        <div className="flex items-center gap-3" data-id="element-3660">
          <div className="w-10 h-10 rounded-xl bg-indigo-100 text-indigo-700 flex items-center justify-center font-black text-lg shadow-sm border border-indigo-200" data-id="element-3661">
            {selectedGroup}
          </div>
          <div className="text-left" data-id="element-3662">
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-0.5" data-id="element-3663">
              Huidige Groep
            </span>
            <span className="font-bold text-slate-800 text-sm flex items-center gap-1.5" data-id="element-3664">
              Groep {selectedGroup}
            </span>
          </div>
        </div>
        <div className={`
          w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200
          ${isOpen ? 'bg-indigo-200 text-indigo-700 rotate-180' : 'bg-slate-100 text-slate-400 group-hover:bg-indigo-100 group-hover:text-indigo-600'}
        `} data-id="element-3665">

          <ChevronDown className="w-4 h-4" strokeWidth={2.5} data-id="element-3666" />
        </div>
      </button>

      {/* Dropdown */}
      <AnimatePresence data-id="element-3667">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -10,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="absolute left-0 right-0 top-full mt-2 bg-white rounded-2xl shadow-xl border border-slate-100 z-50 overflow-hidden p-1.5" data-id="element-3668">

            <div className="text-xs font-bold text-slate-400 uppercase tracking-wider px-3 py-2" data-id="element-3669">
              Kies je groep
            </div>
            {GROUPS.map(group => <button key={group} onClick={() => {
          onSelect(group);
          setIsOpen(false);
        }} className={`
                  w-full flex items-center justify-between p-2.5 rounded-xl transition-all mb-1 last:mb-0
                  ${selectedGroup === group ? 'bg-indigo-50 text-indigo-700 shadow-sm border border-indigo-100' : 'hover:bg-slate-50 text-slate-600 border border-transparent hover:border-slate-100'}
                `} data-id="element-3670">

                <div className="flex items-center gap-3" data-id="element-3671">
                  <div className={`
                      w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm
                      ${selectedGroup === group ? 'bg-indigo-200 text-indigo-800' : 'bg-slate-100 text-slate-500'}
                    `} data-id="element-3672">

                    {group}
                  </div>
                  <span className="font-bold text-sm" data-id="element-3673">Groep {group}</span>
                </div>
                {selectedGroup === group && <div className="bg-indigo-200 p-1 rounded-full" data-id="element-3674">
                    <Check className="w-3 h-3 text-indigo-700" strokeWidth={3} data-id="element-3675" />

                  </div>}
              </button>)}
          </motion.div>}
      </AnimatePresence>
    </div>;
}